<template>
    <a href="/" class="md:text-3xl md:leading-none font-brick block text-xl leading-none transition duration-150">
      <div class="inline" :class="logo_color_classes()">Freshly<br>Ground<br>Copy</div>
      <span class="" :class="dash_color_classes()"> — </span>
      <h1 class="md:text-3xl md:leading-none inline-block mb-0 text-xl leading-none lowercase" :class="h1_color_classes()" >{{ heading_1_content() }}</h1>
    </a>
</template>

<script>

export default {

  props: {
    h1_content: {
      required: true,
      type: String,
    },
    showing: {
      required: true,
      type: Boolean,
    },
  },
  methods: {
    heading_1_content() {
      if (location.pathname.indexOf('blog/') === 1) { return 'blog'; }
      return this.h1_content;
    },
    isHomePage() {
      return location.pathname == '/';
    },
    logo_color_classes() {
      if (this.showing) { return 'text-white';}
      if (location.pathname == '/') { return 'text-black dark:text-gray-50'; }
      return "text-white";
    },
    dash_color_classes() {
      if (this.showing) { return 'hidden';}
      if (location.pathname == '/') { return 'hidden'; }
      return "text-black";
    },
    h1_color_classes() {
      if (this.showing) { return 'hidden';}
      return "text-black";
    },
    is_having_classes() {
      if (this.showing) { return 'hidden';}

    }
  }

}

</script>
